// extracted by mini-css-extract-plugin
export default {"container":"ProgressBar_container__bkBCr","progressBar":"ProgressBar_progressBar__5X2M7","description":"ProgressBar_description__rHINz"};